import { useState } from 'react';
import { Skeleton } from '@mui/material';
import { VideoPlayer } from '@/components/shared/video-player';
import { useSetTitle } from '@/hooks/use-set-title';
import { useLessons } from '@/packages/eduplay/context/lessons';

export const VideoLesson = () => {
  const { lessonVideo, courseId, handleUpdateLessonProgress, courseName } =
    useLessons();
  const [progress, setProgress] = useState(0);
  useSetTitle(courseName ?? 'Aula');

  const handleProgress = (percentage: number) => {
    setProgress(percentage);
  };

  const handlePause = () => {
    handleUpdateLessonProgress?.(progress, courseId!);
  };

  const handleEnded = () => {
    handleUpdateLessonProgress?.(100, courseId!);
  };

  if (!lessonVideo) return <Skeleton variant="rounded" height={400} />;

  return (
    <VideoPlayer
      url={lessonVideo}
      onProgress={handleProgress}
      onPause={handlePause}
      onEnded={handleEnded}
    />
  );
};
